import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { storeNameColumn } from 'TableCommon/defaultColumns'
import { formatValidNumber, getDifferenceWithPrecision, getNumberWithCurrency } from 'utils'

import Box from '@mui/material/Box'

const TitleIcons = storeNameColumn.RowRenderer

function TableClubCardRow({ data, index, style }) {
  const { t: translate } = useTranslation()
  const { showModal, maxRevenueClub, stores } = data
  const store = stores[index]
  const modalHandler = () => showModal(store)
  const percentOfMaxRevenueClub = Math.round((100 * store.revenueClubCurrent) / maxRevenueClub)

  return (
    <Box
      style={style}
      onClick={modalHandler}
      className={classNames('row cursor-pointer', { 'is-temporary-closed': store.temporaryClosed })}
    >
      <div className="row-wrapper flex-row">
        <div className="cell-bar" style={{ width: `${percentOfMaxRevenueClub}%` }} />

        <div className="cell-title flex-row">
          <TitleIcons {...data} store={store} />
        </div>

        <div className="cell-category tablet-portrait-up-only">
          <span className={classNames('category', `is-${store.cluster === '-' ? 'none' : store.cluster.toLocaleLowerCase()}`)}>
            {store.cluster}
          </span>
        </div>

        <div className="cell cell-clubRevenue">
          <span>
            {getNumberWithCurrency({
              currency: store.currency,
              number: store.revenueClubCurrent,
              precision: 0,
              translate,
            })}
          </span>
        </div>

        <div className="cell cell-percentRevenue">
          <span>
            {
              getDifferenceWithPrecision({
                number: store.clubShareCurrent,
                precision: 0,
                translate,
              }).value
            }
          </span>
        </div>

        <div className="cell cell-value">
          <span>
            {getNumberWithCurrency({
              currency: store.currency,
              number: store.transactionValueClubCurrent,
              precision: 0,
              translate,
            })}
          </span>
        </div>

        <div className="cell cell-newCards">{formatValidNumber(store.clubCardsCurrent)}</div>
      </div>
    </Box>
  )
}

TableClubCardRow.propTypes = {
  data: PropTypes.shape({
    maxRevenueClub: PropTypes.number,
    showModal: PropTypes.func,
    stores: PropTypes.arrayOf(PropTypes.object),
  }),
  index: PropTypes.number,
  style: PropTypes.object,
}

export default TableClubCardRow
